import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, Outlet } from "react-router-dom";
import { AuthProvider, useAuth } from "@/lib/auth";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import NewEstimate from "@/pages/NewEstimate";
import EstimatesList from "@/pages/EstimatesList";
import EstimateDetail from "@/pages/EstimateDetail";
import Clients from "@/pages/Clients";
import FollowUps from "@/pages/FollowUps";
import Settings from "@/pages/Settings";
import { PaymentSuccess, PaymentCancel } from "@/pages/Payment";
import DashboardLayout from "@/components/DashboardLayout";
import { Loader2 } from "lucide-react";

function RequireAuth() {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center"><Loader2 className="w-6 h-6 animate-spin text-primary" /></div>;
  if (!user) return <Navigate to="/login" replace />;
  return (
    <DashboardLayout>
      <Outlet />
    </DashboardLayout>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Toaster position="top-right" richColors />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/payment/cancel" element={<PaymentCancel />} />
          <Route path="/app" element={<RequireAuth />}>
            <Route index element={<Dashboard />} />
            <Route path="new-estimate" element={<NewEstimate />} />
            <Route path="estimates" element={<EstimatesList />} />
            <Route path="estimates/:id" element={<EstimateDetail />} />
            <Route path="clients" element={<Clients />} />
            <Route path="followups" element={<FollowUps />} />
            <Route path="settings" element={<Settings />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}
